import {ID, ListRequest} from "../../../types/global.d";
import {PrimaryTimberClass, TimberClass} from "./TimberClass.ts";
import {PrimaryTimberType, TimberType} from "./TimberType.ts";
import {PrimaryTimberStorage, TimberStorage} from "./TimberStorage.ts";
import {timberStorageApi} from "../../apis/TimberStorage.api.ts";
import {timberClassApi} from "../../apis/TimberClass.api.ts";
import {timberTypeApi} from "../../apis/TimberType.api.ts";
import {ShipmentState} from "./ShipmentState";
import {ShipmentType} from "./ShipmentType";
import {Cutting, PrimaryCutting} from "./Cutting.ts";
import {cuttingApi} from "../../apis/Cutting.api.ts";

export interface CordwoodGroupQueryRequest {
    list: ListRequest,
    filter: {
        classId?: ID[],
        typeId?: ID[],
        buyerId?: ID,
        ownerId?: ID,
        cuttingId?: ID[],
        storageId?: ID[],
        shipmentId?: ID,
        shipmentDefined?: boolean,
        startCreate?: Date,
        endCreate?: Date,
        startShipment?: Date,
        endShipment?: Date,
    }
}

export interface CordwoodGroupWithShipmentsQueryResult {
    id: ID;
    key: string;
    reportKey: string;
    cuttingId: ID;
    storageId: ID;
    buyerId?: ID;
    shipmentAt?: Date;
    state: ShipmentState;
    shipmentType: ShipmentType;
    totalVolume: number,
}

export interface CordwoodGroupQueryResult {
    timberClassId: ID,
    timberTypeId: ID,
    cuttingId: ID,
    storageId: ID,
    totalVolume: number,
}

export interface CordwoodClassGroup {
    timberClass: TimberClass,
    timberType: TimberType,
    sum: number,
}

export interface CordwoodStorageGroup {
    storage: TimberStorage,
    items: Array<CordwoodClassGroup>,
    itemMap: Record<string, CordwoodClassGroup>,
    sum: number,
}

export interface CordwoodCuttingGroup {
    cutting: Cutting,
    items: Array<CordwoodStorageGroup>,
    itemMap: Record<string, CordwoodStorageGroup>,
    sum: number,
}

const createCordwoodClassGroup = async (dispatch, item: CordwoodGroupQueryResult): Promise<CordwoodClassGroup> => {
    return {
        timberClass: (await dispatch(timberClassApi.endpoints.getTimberClass.initiate(PrimaryTimberClass.fromId(item.timberClassId))))?.data,
        timberType: (await dispatch(timberTypeApi.endpoints.getTimberType.initiate(PrimaryTimberType.fromId(item.timberTypeId))))?.data,
        sum: item.totalVolume,
    }
}

const createCordwoodStorageGroup = async (dispatch, item: CordwoodGroupQueryResult): Promise<CordwoodStorageGroup> => {
    const group = await createCordwoodClassGroup(dispatch, item)
    const key = item.timberClassId + '_' + item.timberTypeId
    return {
        storage: (await dispatch(timberStorageApi.endpoints.getTimberStorage.initiate(PrimaryTimberStorage.fromId(item.storageId))))?.data,
        itemMap: {
            [key]: group
        },
        items: [group],
        sum: item.totalVolume,
    }
}

const createCordwoodCuttingGroup = async (dispatch, item: CordwoodGroupQueryResult): Promise<CordwoodCuttingGroup> => {
    const group = await createCordwoodStorageGroup(dispatch, item)
    const key = item.storageId
    return {
        cutting: (await dispatch(cuttingApi.endpoints.getCutting.initiate(PrimaryCutting.fromId(item.cuttingId))))?.data,
        itemMap: {
            [key]: group
        },
        items: [group],
        sum: item.totalVolume,
    }
}

export {
    createCordwoodCuttingGroup,
    createCordwoodStorageGroup,
    createCordwoodClassGroup,
}

export interface CordwoodTotalQueryRequest {
    cuttingId: ID,
    storageId: ID,
    shipmentId: ID,
    shipmentDefined: boolean,
}

export interface CordwoodTotalQueryResult {
    commited: boolean,
    totalVolume: number,
}
